import React from 'react';
import contactHeroStyle from '../styles/ContactUs/HeroSection.module.css';

const HeroSection = ({image,title,description}) => {
  return (
    <section className={contactHeroStyle.hero}>
        <img 
            className={contactHeroStyle.conbgImg} 
            src={image} 
            alt="Hero" 
        />
      <div className={contactHeroStyle.overlay}>
        <h1 className={contactHeroStyle.title}>{title}</h1>
        <p className={contactHeroStyle.subtitle}>
          {description}
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
